import React from "react";

const OffsetBar = ({ x, y, width, height, name, fill }) => {
  const offsetX = x + width / 2;

  return (
    <g className="recharts-layer recharts-bar-rectangle">
      <path
        fill={fill}
        width={width}
        height={height}
        name={name}
        x={offsetX}
        y={y}
        radius="0"
        className="recharts-rectangle"
        d={`M ${offsetX},${y} h ${width} v ${height} h -${width} Z`}
      ></path>
    </g>
  );
};

export default OffsetBar;
